import React from 'react';
import Helmet from "react-helmet";
import Label from "../../assets/label.png"

const Prep = ({ }) => {
  return (
    <div><Helmet title="Prepping Service Notes" />
      <h1>Prepping Service Notes</h1>
      <p>We are now able to prep and ship your orders to Amazon.</p>
    <p>Prep prices:</p>
      <ul>
        <li>8x10: $1.17 per sku</li>
        <li>11x14: $1.28 per sku</li>
        <li>Surcharge if less than 20 of a sku: $0.15 per sku</li>
      </ul>
    <p>There are no other fees. Shipping to Amazon is billed to your account.
    </p>
    <p>Limits: </p>
      <ul>
      <li>No minimum, but keep in mind the surcharge if there are less than 20 of a sku, and that shipping to amazon still needs to be paid so it is best to spread that out with a full box (80 or so?)</li>
        <li>
          ~3000 sku maximum in one order. If you need more than that it is ok to submit additional orders, but we will alternate between clients if we are busy. You may also email us to ask if it is ok for more than that in one order.
        </li>
     </ul>
     <p>Turnaround time - usually a couple days to a week, varies greatly based on how busy we are, but we should be able to complete any normalish order within a few days. We generally do not prep orders on Fridays or Saturdays.</p> 

    <h2>Seller Central Account Access</h2>
    <p>In order to offer the prep service we need access to your Seller Central account. This is so we can access the Inventory > Manage FBA Shipments page.</p>
    <p>Please send a user access link for our email: orders@qprints.com. Once we accept the invite then please allow us access to Manage FBA Inventory/Shipments only.</p>
    <p>It is possible for us to do prep without access to your Seller Central account, but it is more tedious as we would have to send you the box contents, size and weight and then wait for you to send us the shipping labels. We would prefer to not do this as we don't want to have boxes of stuff sitting around waiting for a shipping label.</p>
    <h2>Filenames Must Include the FNSKU</h2>
    <p>Our entire prep process is built around matching the FNSKU on the label to the filename that is printed on the back of each print. The filename of each image MUST include the FNSKU that it belongs to. Please make sure the FNSKU is separated from the rest of the filename by a space or dash - do not let other text meet the FNSKU without some sort of separator as we need to be able to clearly see the last few digits of the FNSKU. For example, X00GHT123-MY-cool-img.jpg is fine, but do not do X00GHT123MY-cool-img.jpg as it looks like 3MY is the last 3 digits of the FNSKU when it is really 123.</p>
    <h2>Preparing an Order that Needs Prep</h2>
    <p>You need to create a Shipping Plan and upload it to Seller Central - please make one plan per size needed. It is ok when you order in our system to mix 8x10 and 11x14 in the same FBQ order, but you must create a plan for each size in Seller Central. We cannot prep an order where the shipping plan contains more than one size print as it is difficult to know what size mailer the label goes on.</p>
    <p>We ask that you create the Shipping Plan(s), then go thru the first couple steps. This way if there are any errors or inventory issues you will see them before we get to this step.</p>
    <p>When submitting the order thru our system please reference whatever the Shipping Plan name is (or use the FBQ order number as the plan name) so we can match it up to the correct plan in Seller Central.</p>
    <p>Please make the shipping plan the same day you make the order in FBQ. We like to be able to see an order that needs prep and then work on it and not have to wait for someone to create the shipping plan. We won't make any prints until the plan is available.</p>
    <h2>Labels</h2>
    <p>We make labels off of the SKU list that is available once the Shipping Plan has been submitted and the first few screens have been saved.</p>
    <p>The labels we use are 3" x 2".</p>
    <p>Our labels contain the following information, pulled directly from the SKU contents TSV file:</p>
    <ul>
      <li>FNKSU Barcode with text below</li>
      <li>Title, truncated after 2 lines</li>
      <li>Condition</li>
      <li>ASIN</li>
      <li>Our own prepping info - Batch number, item sequence number, item total quantity, label sequence number</li>
      </ul>
    <p>Here is an example of a Label:</p>
    <img src={Label} />
    <br /><br />
    <h2>Mailers</h2>
    <p>We use white rigid mailers from MailersUSA. 8x10 prints go in #3 9" x 11.5" mailers, 11x14s go in #6 12.75" x 15" mailers.</p>
    </div>

  )
};

export default Prep;
